module.exports = __webpack_public_path__ + "static/media/finish.59a16e7a.png";